


































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import IFormLayout, { isIFormLayout } from '@frontend/types/modules/form/IFormLayout';
import IFormInput from '@frontend/types/modules/form/IFormInput';
import { isIFormLayoutInput } from '@frontend/types/modules/form/IFormLayoutInput';
import FormInput from './FormInput.vue';

@Component({
	components: {
		FormInput
	},
	name: 'FormLayout'
})
export default class FormLayout extends Vue {
	@Prop(Object)
	protected readonly layout!: IFormLayout;

	@Prop(Object)
	protected readonly inputsById!: Record<string, IFormInput>;

	@Prop(Object)
	protected readonly dateFormats!: Record<string, string>;

	protected get layoutType(): string {
		return `${this.layout.type.replace('layout_', '').replace(/_/g, '-')}`;
	}

	protected getDataTypeForInput(formInput: IFormInput): string {
		switch (formInput.type) {
			case 'Honeypot':
				// Don't explicitly output "Honeypot"
				return 'TextInputExtra';
			default:
				return formInput.type;
		}
	}

	protected isIFormLayout(layoutItem: any): boolean {
		return isIFormLayout(layoutItem);
	}

	protected isIFormLayoutInput(layoutItem: any): boolean {
		return isIFormLayoutInput(layoutItem);
	}
}
